import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LabelTableColumnsType } from 'entities/Files/types';
import { FormSelect } from 'shared/ui/Select/FormSelect';
import { InputField } from 'shared/ui/InputField';
import { SmallIconButton } from 'shared/ui/SmallIconButton';
import { Box } from '@mui/material';
import { IconButton } from 'shared/ui/IconButton';

type TableLabelsProps = {
	columns: LabelTableColumnsType[];
	onChange: (name: string, value: any) => void;
};

const TableLabels: FC<TableLabelsProps> = ({ columns, onChange }) => {
	const { t } = useTranslation();

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: '30px' }}>
			{columns?.map((item, i) => {
				return (
					<Box key={`column_${i}`} sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flex: 1 }}>
							<Box sx={{ display: 'flex', gap: 1 }}>
								<FormSelect
									name={`columns.${i}.type`}
									placeholder=""
									options={labelTypesOptions}
									value={item.type}
									onSelect={(value) => onChange(`columns.${i}.type`, value as string)}
									sx={{ margin: 0 }}
									required
									size="small"
								/>

								<InputField
									name={`columns.${i}.name`}
									label={''}
									placeholder={t('files.labels.research')}
									required
									size="small"
									sx={{ margin: 0 }}
								/>
							</Box>
							<InputField
								name={`columns.${i}.description`}
								label={''}
								placeholder={t('shared_texts.description')}
								size="small"
								sx={{ margin: 0 }}
								multiline
								maxRows={3}
							/>
						</Box>
						{i !== 0 && (
							<IconButton
								iconId={'trush_icon_red'}
								sxWrapper={{
									height: 'auto',
									width: 'auto',
									backgroundColor: 'transparent',
								}}
								onClick={(e) => {
									e.stopPropagation();
									onChange(
										'columns',
										columns.filter((_, index) => index !== i),
									);
								}}
							/>
						)}
					</Box>
				);
			})}

			<SmallIconButton
				iconId="add_round"
				onClick={(e) => {
					e.stopPropagation();
					onChange('columns', [
						...columns,
						{
							name: '',
							type: 'string',
							description: '',
						},
					]);
				}}
			/>
		</Box>
	);
};

export default TableLabels;

const labelTypesOptions = [
	{ value: 'string', label: 'shared_texts.string' },
	{ value: 'number', label: 'shared_texts.number' },
];
